module.exports = __webpack_public_path__ + "img/hero-sm.48468d42.svg";